import React from "react";
import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";

import { auth, db } from "./firebase-config";
import { collection, getDocs, query, where } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

export const UserContext = React.createContext();

export const UserStorage = ({ children }) => {
  const [data, setData] = React.useState(null);
  const [permission, setPermission] = React.useState(null);
  const [modules, setModules] = React.useState(null);
  const [changePassword, setChangePassword] = React.useState(null);

  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    onAuthStateChanged(auth, (currentUser) => {
      setData(currentUser);
      getPermission(currentUser.email);
    });
    async function getPermission(user) {
      try {
        const queryPermission = collection(db, "permission-user");
        const q = query(queryPermission, where("email", "==", user));
        const docs = await getDocs(q);
        docs.forEach((doc) => {
          setPermission(doc.data().permission);
          window.localStorage.setItem("permission", doc.data().permission);
          setModules(doc.data().modules);
          window.localStorage.setItem("modules", doc.data().modules);
          setChangePassword(doc.data().changePassword);
          window.localStorage.setItem("changePassword", doc.data().changePassword);
        });
      } catch (e) {
        console.error(e);
      }
    }
  }, []);

  async function userLogin(auth, loginEmail, loginPassword) {
    try {
      setLoading(true);
      const user = await signInWithEmailAndPassword(
        auth,
        loginEmail,
        loginPassword
      );
      navigate("/");
    } catch (error) {
      setError(error);
      console.error(error.message);
    } finally {
      setLoading(false);
    }
  }

  async function userLogout(auth) {
    await signOut(auth);
    setPermission(null);
    window.localStorage.removeItem("permission");
  }

  return (
    <UserContext.Provider
      value={{
        userLogin,
        userLogout,
        permission,
        modules,
        changePassword,
        data,
        error,
        loading,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
